(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snooze-announcement"] && !Shopify.designMode) return;
  try {
    
  class SnoozeAnnouncement extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const key = `${this.dataset.storageKey}-${this.querySelector('a')?.textContent.trim()}`;
      try { this.hidden = sessionStorage.getItem(key) === 'dismissed'; } catch {}
      this.querySelector('button')?.addEventListener('click', () => {
        this.hidden = true;
        try { sessionStorage.setItem(key,'dismissed'); } catch {}
        document.querySelector('header a')?.focus({preventScroll:true});
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('snooze-announcement')) customElements.define('snooze-announcement', SnoozeAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snooze-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class SnoozeCollectionTabs extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected) return;
      this.controller?.abort();
      this.controller = new AbortController();
      document.addEventListener('shopify:section:load', event => {
        if (event.target.contains(this)) this.initialize();
      }, {signal:this.controller.signal});
      const panels = [...this.querySelectorAll('.snooze-tabs__panel')];
      const controls = this.querySelector('[role="tablist"]');
      if (!controls) return;
      controls.replaceChildren();
      const tabs = panels.map(panel => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.id = panel.getAttribute('aria-labelledby');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.textContent = panel.querySelector('h3').textContent.trim();
        controls.append(tab);
        return tab;
      });
      controls.hidden = tabs.length === 0;
      if (!tabs.length) return;
      const activate = (tab, focus = false) => {
        tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
        panels.forEach(panel => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
          if (!panel.hidden) panel.querySelector('snooze-carousel')?.update?.();
        });
        if (focus) { tab.focus({preventScroll:true}); tab.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}); }
      };
      const remembered = this.dataset.activeTab;
      const initial = tabs.find(tab => tab.id === remembered) || tabs[0];
      activate(initial);
      controls.hidden = false;
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('.snooze-tabs__panel');
        const tab = tabs.find(item => item.getAttribute('aria-controls') === panel?.id);
        if (tab) { this.dataset.activeTab = tab.id; activate(tab); }
      }, {signal:this.controller.signal});
      tabs.forEach(tab => {
        tab.addEventListener('click', () => { this.dataset.activeTab = tab.id; activate(tab); }, {signal:this.controller.signal});
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next = tabs.indexOf(tab);
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          const target = tabs[(next + tabs.length) % tabs.length];
          this.dataset.activeTab = target.id;
          activate(target,true);
        }, {signal:this.controller.signal});
      });
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); }
  }
  if (!customElements.get('snooze-collection-tabs')) customElements.define('snooze-collection-tabs', SnoozeCollectionTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snooze-offer-strip"] && !Shopify.designMode) return;
  try {
    
 class SnoozeOfferStrip extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();this.querySelector('button')?.addEventListener('click',e=>{const paused=this.toggleAttribute('data-paused');e.currentTarget.setAttribute('aria-pressed',String(paused));},{signal:this.controller.signal});}disconnectedCallback(){this.controller?.abort();}}
 if(!customElements.get('snooze-offer-strip'))customElements.define('snooze-offer-strip',SnoozeOfferStrip);

  } catch(e) { console.error(e); }
})();
})();
